import {
  Box,
  Flex,
  Image,
  Stack,
  Text,
  VStack,
  HStack,
  Grid,
} from "@chakra-ui/react";
import React, { useState } from "react";

const ExamQuestions = ({ data, answers, setAnswers, selectedQuestionIdx }) => {
  const baseUrl = "https://asquera.com/asquera";
  const [loading, setLoading] = useState(false);

  return (
    <VStack
      w="100%"
      spacing="20px"
      h="100%"
      onSelect={(e) => e.preventDefault()}
    >
      {/* question */}
      <Box
        w="100%"
        bg="white"
        border="1px solid"
        borderColor="gray.300"
        borderRadius="12px"
        p={6}
        boxShadow="0 2px 8px rgba(0,0,0,0.08)"
      >
        <Stack
          flexDirection={{ base: "column", lg: "row" }}
          spacing={{ base: 4, lg: 6 }}
          alignItems="flex-start"
        >
          <VStack 
            w={{ base: "100%", lg: data?.image ? "60%" : "100%" }} 
            alignItems="flex-start"
            spacing={4}
          >
            {data?.comprehension && (
              <Box w="100%">
                <Text
                  fontSize="18px"
                  fontWeight="700"
                  textDecoration="underline"
                  mb={2}
                  color="gray.800"
                >
                  Comprehension
                </Text>
                <Text 
                  fontSize="16px" 
                  color="gray.700"
                  lineHeight="1.6"
                  whiteSpace="pre-wrap"
                >
                  {data?.comprehension}
                </Text>
              </Box>
            )}
            <Box
              w="100%"
              onMouseDown={(e) => e.preventDefault()}
            >
              <Text
                fontSize="18px"
                fontWeight="700"
                textDecoration="underline"
                mb={2}
                color="gray.800"
              >
                Question
              </Text>
              <Box
                fontSize="16px"
                color="gray.800"
                lineHeight="1.6"
                sx={{
                  '& p': {
                    margin: 0,
                  },
                  '& *': {
                    maxWidth: '100%',
                  }
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: data?.question }} />
              </Box>
            </Box>
          </VStack>

          {data?.image && (
            <Box flex={1} display="flex" justifyContent="center" alignItems="flex-start">
              <Image
                src={`${baseUrl}/${data?.image}`}
                w={{ base: "100%", lg: "auto" }}
                maxH="400px"
                objectFit="contain"
                borderRadius="8px"
              />
            </Box>
          )}
        </Stack>
      </Box>

      {/* answers */}
      <Box w="100%">
        <Grid
          role="group"
          aria-labelledby="my-radio-group"
          templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }}
          gap={3}
          w="100%"
        >
          {data?.answers?.map((val, index) => {
            const letter = String.fromCharCode(65 + index); // A, B, C, D
            const isSelected = answers[selectedQuestionIdx]?.answer_id == val?.id;
            
            return (
              <Box key={val?.id} w="100%">
                <label
                  htmlFor={`answer_${index}`}
                  style={{
                    display: "block",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  <Flex
                    w="100%"
                    alignItems="center"
                    p={4}
                    borderRadius="12px"
                    border="2px solid"
                    borderColor={isSelected ? "main_1" : "gray.300"}
                    bg={isSelected ? "blue.50" : "white"}
                    boxShadow={isSelected ? "0 4px 12px rgba(0,0,0,0.15)" : "0 2px 4px rgba(0,0,0,0.1)"}
                    transition="all 0.2s"
                    _hover={{
                      borderColor: "main_1",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    <Box position="relative" mr={3} flexShrink={0}>
                      <input
                        type="radio"
                        value={val?.id}
                        name="answer"
                        id={`answer_${index}`}
                        style={{
                          position: "absolute",
                          opacity: 0,
                          width: "40px",
                          height: "40px",
                          cursor: "pointer",
                          zIndex: 2,
                        }}
                        onClick={(e) => {
                          setLoading(true);
                          const formData = {
                            question_id: data?.id,
                            answer_id: e?.target?.value,
                          };
                          let newAnswers = answers;
                          answers[selectedQuestionIdx] = formData;
                          setAnswers(() => newAnswers);
                          setTimeout(() => {
                            setLoading(false);
                          }, 300);
                        }}
                        checked={isSelected}
                      />
                      <Box
                        as="span"
                        w="40px"
                        h="40px"
                        borderRadius="50%"
                        border="2px solid"
                        borderColor={isSelected ? "main_1" : "gray.400"}
                        bg={isSelected ? "main_1" : "white"}
                        color={isSelected ? "white" : "gray.700"}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        fontWeight="bold"
                        fontSize="18px"
                        position="relative"
                        zIndex={1}
                        transition="all 0.2s"
                      >
                        {letter}
                      </Box>
                    </Box>
                    <Text fontSize="18px" flex={1} lineHeight="1.5">
                      {val?.answer}
                    </Text>
                  </Flex>
                </label>
              </Box>
            );
          })}
        </Grid>
      </Box>
    </VStack>
  );
};

export default ExamQuestions;
